import { Star } from "lucide-react";
import { DiscordChannel, GuildConfig } from "@/lib/api";
import { Section, Field } from "@/components/panel/Section";
import { ChannelPicker } from "@/components/panel/ChannelPicker";

interface Props {
  config: GuildConfig;
  channels: DiscordChannel[];
  onChange: (v: GuildConfig["ticket_feedback"]) => void;
}

export function FeedbackTab({ config, channels, onChange }: Props) {
  const cfg = config.ticket_feedback;
  const update = <K extends keyof typeof cfg>(k: K, v: (typeof cfg)[K]) =>
    onChange({ ...cfg, [k]: v });

  return (
    <Section
      icon={Star}
      title="Ticket Feedback"
      description="When staff clicks “Close”, a form appears in the ticket channel: the ticket author submits a ⭐ rating and comment; **then** the ticket closes, a public embed goes to the channel below, transcript flow unchanged."
      enabled={cfg.enabled}
      onToggle={(v) => update("enabled", v)}
    >
      <div className="rounded-lg border border-dashed border-border bg-muted/25 p-4 text-sm text-muted-foreground space-y-2">
        <p className="font-medium text-foreground">How it works</p>
        <p>
          <strong>No separate slash command.</strong> When enabled, closing a ticket via the bot’s close flow can show
          a rating form in the ticket first; after the member submits ⭐ + comment, the bot posts the public summary to the
          channel below and completes your normal close/transcript behavior.
        </p>
      </div>

      <Field
        label="Public ratings channel"
        hint="The bot posts the rating + comment embed here (everyone who can see the channel sees the feedback)."
      >
        <ChannelPicker
          channels={channels}
          value={cfg.channel_id}
          onChange={(v) => update("channel_id", v === "__none__" ? "" : v)}
        />
      </Field>
    </Section>
  );
}
